<template>
  <div>
    <!-- 流水匹配 -->
    <el-dialog :title="$t('message.flowMatching')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1480px" center>
      <div class="content">
        <div class="text">
          <!--  '已匹配', -->
          <div class="item">{{ $t('message.alreadyMatched') }} <span>{{ detail.confirm_count }}</span> </div>
          <!-- unmatch: '未匹配', -->
          <div class="item">{{ $t('message.unmatch') }} <span>{{ detail.match_count }}</span> </div>
        </div>
        <div class="table">
          <ol>
            <!-- 流水编号 -->
            <li class="red">
              {{ $t('message.flowNumber') }}
            </li>
            <!-- 流水明细 -->
            <li class="red">
              {{ $t('message.journalDetail') }}
            </li>
            <!-- 客户id -->
            <li>
              {{ $t('message.userID') }}
            </li>
            <!-- 入金名义 -->
            <li>
              {{ $t('message.depositName') }}
            </li>
            <!-- 财务操作时间 -->
            <li>
              {{ $t('message.financialOperationTim') }}
            </li>
            <!--  出金金额（円） -->
            <li>
              {{ $t('message.sum') }}
            </li>

            <!-- 状态 -->
            <li>
              {{ $t('message.status') }}
            </li>
          </ol>
          <!-- 详细 -->
          <div class="detail" v-for="(item, index) in detail.conflict_list" :key="index">
            <div class="label">
              <div class="item">{{ item.bank_bill.serial_number }}</div>
              <div class="item">{{ item.bank_bill.account }}</div>
            </div>
            <div class="list">
              <ul v-for="(items, indexs ) in item.user_bill" :key="indexs" :class="{ pink: !items.status }">
                <li>{{ items.user_id }}</li>
                <li>{{ items.pay_realname }}</li>
                <li>{{ items.predict_arrival_at }}</li>
                <li>{{ items.amount }}</li>
                <li>{{ items.status ? $t('message.alreadyMatched') : $t('message.unmatch') }}</li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,

    };
  },
  methods: {
    // 保存
    save() {


    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;


  .text {
    display: flex;
    margin-bottom: 15px;
    font-size: 20px;

    .item {
      margin-right: 20px;

      span {
        color: #B4272D;
      }
    }
  }

  .detail {
    display: flex;

    .label {
      flex: 2;
      display: flex;

      .item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #EDEFF4;
        border-top: 0;

        &:nth-last-child(1) {
          border-left: 0
        }
      }
    }

    .list {
      flex: 5;

      ul {
        padding: 0;
      }

      li {
        border-right: 1px solid #EDEFF4;
        padding: 15px 0;
      }
    }
  }
}

.red {
  background-color: #B4272D;
  color: #fff;
}

.pink {
  background-color: rgba(245, 108, 108, 0.5);

}
</style>